import { DOMAnimations } from './dom'

let type
let url

export const classesInjection = (view) => {
  view = view ?? document.querySelector('[data-router-view]')

  const classes = view.getAttribute('data-class-injection')
  // console.log('classes injection →', classes)

  requestAnimationFrame(() => {
    document.body.removeAttribute('class')
    view.removeAttribute('data-class-injection')
    document.body.classList.add(...classes.split(' '))

    // requestAnimationFrame(() => {
    //   activeProjects()
    //   activeLinks()
    //   dynamicLinks()
    // })
  })
}

const dynamicLinks = () => {
  //   console.log('dynamic links', url)
  const links = document.querySelectorAll('[data-dynamic-link]')
  links.forEach((link) => {
    if (url) link.href = url
  })
}

export const activeLinks = () => {
  //   console.log('active links')

  const links = document.querySelectorAll('.menu a')

  for (let i = 0; i < links.length; i += 1) {
    const link = links[i]
    const href = link.href.endsWith('/') ? link.href : `${link.href}/`
    const currentHref = window.location.href.endsWith('/')
      ? window.location.href
      : `${window.location.href}/`

    const parentLink = link.closest('li')
    if (href === currentHref) {
      parentLink.classList.add('current-menu-item')
      link.setAttribute('aria-current', 'page')
    } else {
      parentLink.classList.remove('current-menu-item')
      link.removeAttribute('aria-current')
    }
  }
}

export const activeProjects = () => {
  //   console.log('active projects')
  const links = document.querySelectorAll('a.c-side__project')

  for (let i = 0; i < links.length; i += 1) {
    const link = links[i]
    const href = link.href.endsWith('/') ? link.href : `${link.href}/`
    const currentHref = window.location.href.endsWith('/')
      ? window.location.href
      : `${window.location.href}/`

    const node = link.parentNode

    if (href === currentHref) {
      node?.classList.add('--active')
      link.setAttribute('aria-current', 'page')

      const hasDetails = node?.classList.contains('--details')
      //   console.log('show', link, node, hasDetails)

      if (hasDetails) {
        const details = node.querySelector('.c-side__details')

        node.classList.add('--details-active')
        DOMAnimations.slideDown(details)
      }
    } else {
      node?.classList.remove('--active')
      link.removeAttribute('aria-current')
      const hasDetails = node?.classList.contains('--details-active')
      //   console.log('should hide', node)
      if (hasDetails) {
        const details = node.querySelector('.c-side__details')
        node.classList.remove('--details-active')
        DOMAnimations.slideUp(details), 300
      }
    }
  }
}
